import * as api from '../api';
import router from '../router';
import persistentStorage from '@/utils/persistentStorage';

const state = {
    user: persistentStorage.getItem('user'),
    token: persistentStorage.getItem('token'),

    adminCompany: persistentStorage.getItem('adminCompany'),

    isPending: false,
    error: null,

    loginPending: false,
    loginError: null,
};

const getters = {
    isLoggedIn(state) {
        return Boolean(state.user && state.token);
    },

    company(state) {
        return state.adminCompany ?? state.user.company ?? null;
    },
};

const mutations = {
    REFRESH_PENDING(state) {
        state.isPending = true;
    },

    REFRESH_SUCCESS(state, user) {
        state.user = user;
        state.isPending = false;
        state.error = null;

        persistentStorage.setItem('user', user);
    },

    REFRESH_FAILURE(state, error) {
        state.isPending = false;
        state.error = error;
    },

    LOGIN_PENDING(state) {
        state.loginPending = true;
    },

    LOGIN_SUCCESS(state, { user, token }) {
        state.user = user;
        state.token = token;
        state.loginPending = false;
        state.loginError = null;

        persistentStorage.setItem('user', user);
        persistentStorage.setItem('token', token);
    },

    LOGIN_FAILURE(state, error) {
        state.loginError = error.message;
        state.loginPending = false;
    },

    LOGOUT(state) {
        state.user = null;
        state.token = null;
        state.adminCompany = null;

        persistentStorage.removeItem('user');
        persistentStorage.removeItem('token');
        persistentStorage.removeItem('adminCompany');
    },

    SET_ADMIN_COMPANY(state, company) {
        state.adminCompany = company;
        persistentStorage.setItem('adminCompany', company);
    },
};

const actions = {
    async refreshUser({ state, commit, dispatch }) {
        if (!state.user) return;

        commit('REFRESH_PENDING');
        const res = await api.get(`/users/${state.user.id}`);
        if (!res.ok) {
            if (res.status === 403) {
                return dispatch('logout', { redirect: true });
            }

            return commit('REFRESH_FAILURE', res.error);
        }

        if (res.body.isActive === false) {
            return dispatch('logout', { redirect: true });
        }

        commit('REFRESH_SUCCESS', res.body);
    },

    async login({ commit }, loginDetails) {
        commit('LOGIN_PENDING');
        const res = await api.post('/login', loginDetails);
        if (res.error) return commit('LOGIN_FAILURE', res.error);

        commit('LOGIN_SUCCESS', res.body);

        const { user } = res.body;
        if (user.role === 'owner' && !user.stripeCustomerId) {
            return router.push('/signup/subscription');
        }

        const urlByRole = {
            manager: '/company/dashboard',
            owner: '/company/dashboard',
            admin: '/admin/dashboard',
            driver: '/driver/welcome',
        };

        router.push(urlByRole[user.role] ?? '/');
    },

    async logout({ commit }, { redirect } = {}) {
        commit('LOGOUT');
        if (redirect) router.replace('/');
    },

    async setAdminCompany({ commit }, company) {
        commit('SET_ADMIN_COMPANY', company);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
